module.exports = __webpack_public_path__ + "img/brand_github.301e5129.svg";